import React, { useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import { getImg } from '../../../../Utils/getImg';

type Props = {
	complementary: any;
	handleSubmit: Function;
};

const ComplementProducts = ({ complementary, handleSubmit }: Props) => {
	return (
		<div className='ff-complement-product'>
			<div className='ff-complement-desc'>
				<div>You may also like:</div>
			</div>
			<div className='ff-complement-item-content'>
				{complementary.map((item) => {
					let desc = item.description;
					let title = item.title;

					return (
						<div
							className='ff-complement-item'
							onClick={() => {
								handleSubmit(item.product_id, item.title);
							}}
						>
							<img
								src={
									item.media_link.length > 0
										? item.media_link
										: getImg('icons/no-image.png')
								}
								style={{
									objectFit: item.media_link.length > 0 ? 'contain' : 'scale-down',
								}}
							/>
							<div className='ff-complement-item-desc'>
								{/* <Tooltip
									title={
										<div
											dangerouslySetInnerHTML={{
												__html: title && title.replace(/\n/g, '<br />'),
											}}
										></div>
									}
								> */}
								<div
									dangerouslySetInnerHTML={{
										__html: title && title.replace(/\n/g, '<br />'),
									}}
									style={{ fontWeight: 'bold', fontSize: '14px' }}
								></div>
								{/* </Tooltip> */}
								{/* <Tooltip
									title={
										<div
											dangerouslySetInnerHTML={{
												__html: desc && desc.replace(/\n/g, '<br />'),
											}}
										></div>
									}
								> */}
								<div
									dangerouslySetInnerHTML={{
										__html: desc && desc.replace(/\n/g, '<br />'),
									}}
								></div>
								{/* </Tooltip> */}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default ComplementProducts;
